export default __webpack_public_path__ + "static/media/man-mountain-biking-light-skin-tone_1f6b5-1f3fb-200d-2642-fe0f.97e6df38.png";